import { render, staticRenderFns } from "./HealthPathsDurationStatistics.vue?vue&type=template&id=c56a0e14"
import script from "./HealthPathsDurationStatistics.vue?vue&type=script&lang=ts"
export * from "./HealthPathsDurationStatistics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports